// extracted by mini-css-extract-plugin
export var container = "ImportSales-module--container--V+r9L";
export var content = "ImportSales-module--content--rz7ki";
export var dateField = "ImportSales-module--dateField--PXUSM";
export var noSuppliers = "ImportSales-module--noSuppliers--uSKG1";
export var subHeader = "ImportSales-module--subHeader--btWuL";
export var title = "ImportSales-module--title--KHLsg";